import AppIcon from "@/components/AppIcon";
import { CurrencyValue } from "@/components/tableElements";
import AppPopover from "@/components/AppPopover";
import ClockRewindIcon from "@/components/icons/ClockRewindIcon.vue";
export default {
  name: 'PpcBABudgetCell',
  emits: ["weekly-reset", "weekly-edit", "weekly-popup-shown", "weekly-popup-hidden"],
  components: {
    AppIcon,
    CurrencyValue,
    AppPopover,
    ClockRewindIcon
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    currency: {
      type: String,
      default: ""
    },
    currency_precision: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    is_paused: {
      type: Boolean,
      default: false
    },
    item_id: {
      type: String,
      default: ""
    }
  }
};